/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';

import { formatErrorResponse } from 'responseFormatterFunctions';
import { I18NError } from 'Utils';
import { fetchPost } from 'FetchAPIs';

const url = '/api/v2/deviceTypes';

const messages = defineMessages({
  deviceTypeCreationError: 'Creating device type was unsuccessful. {message}',
  deviceCreationError: 'Creating device was unsuccessful. {message}',
});

export function createV2DeviceTypeAPI(params, userEmailId) {
  return fetchPost(`${url}`, params, { userEmailId }).catch(error => {
    throw new I18NError(messages.deviceTypeCreationError, {
      message: formatErrorResponse(error),
    });
  });
}

export function createDevicesForDeviceTypeAPI(deviceTypeUUID, devices, userEmailId) {
  return fetchPost(`${url}/${deviceTypeUUID}/devices`, devices, { userEmailId }).catch(error => {
    throw new I18NError(messages.deviceCreationError, {
      message: formatErrorResponse(error),
    });
  });
}
